<template>
  <div>
    <div class="title-div">燃气户号管理-添加</div>
    <div class="form-div">

      <el-form :model="form" :rules="rules" hide-required-asterisk label-position="top" label-width="80px" ref="form">
        <el-form-item label="联系人姓名:">
          <el-input v-model="form.contactName" :disabled="disableContactName"></el-input>
        </el-form-item>

        <el-form-item label="联系电话:">
          <el-input v-model="form.telephone" :disabled="disableTelephone"></el-input>
        </el-form-item>

        <el-form-item :required="true" label="用户编号:" >
          <el-input v-model="form.userNumber" :disabled="disableUserNumber"></el-input>
        </el-form-item>

        <el-form-item :required="true"  label="原地址:" prop="originalAddress">
          <el-input v-model="form.originalAddress" type="textarea"
                    autosize :disabled="disableAddress"></el-input>
        </el-form-item>

        <el-form-item :required="true" label="所在地区:" prop="newLocation">
          <el-input v-model="form.newLocation"></el-input>
        </el-form-item>

        <el-form-item :required="true"  label="详细地址:" prop="detailedAddress">
          <el-input v-model="form.detailedAddress"  type="textarea" autosize ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="onSubmit" class="submit-button" type="primary" :loading="loading" >提交</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>

</template>

<script>
  import { addConsulting } from '../../../api/accountNumberManagement'
  import { getUserInfo } from '../../../api/login'
  export default {
    name: 'GasAccountManagement',
    data () {
      return {

        form: {
          userNumber: '', // 用户编号
          contactName: '', // 联系人姓名
          telephone: '', // 联系电话
          originalAddress: '', // 原地址
          newLocation: '', // 所在地区
          detailedAddress: '', // 详细地址
        },
        timer: null,
        //手机号输入框是否禁用
        disableTelephone:true,
        //用户编号输入框是否禁用
        disableUserNumber:true,
        //详细地址输入框是否禁用
        disableAddress:true,
        //联系人输入框是否禁用
        disableContactName:true,
        //按钮加载
        loading:false,

        rules: {
          userNo: [
            {
              required: true,
              message: '请输入用户编号',
              trigger: 'blur'
            }
          ],
          originalAddress: [
            {
              required: true,
              message: '请输入原地址',
              trigger: 'blur'
            }
          ],
          newLocation: [
            {
              required: true,
              message: '请输入地区',
              trigger: 'blur'
            }
          ],
          detailedAddress: [
            {
              required: true,
              message: '请输入详细地址',
              trigger: 'blur'
            }
          ],
        }
      }
    },
    mounted () {
      this.form.contactName = JSON.parse(window.localStorage.userInfo).contacts
      this.form.telephone = JSON.parse(window.localStorage.userInfo).mobile
      this.form.userNumber = this.$route.query.userNumber
      this.form.originalAddress = this.$route.query.detailedAddress

      this.disableTelephone = !this.form.telephone == '';
      this.disableUserNumber = !this.form.userNumber == '';
      this.disableAddress = !this.form.originalAddress == '';
      this.disableContactName = !this.form.contactName == '';
    },
    methods: {

      // 提交
      onSubmit () {
        let that = this;
        this.$refs['form'].validate((valid) => {
          if (valid) {
            that.loading = true;

            const params = {
              uniUserCode: that.form.userNumber,
              detailAddress: that.form.originalAddress,
              appContactName: that.form.contactName,
              appUserPH: that.form.telephone,
              region: '所在地区:' + that.form.newLocation + '。',
              detailAdd: '详细地址:' + that.form.detailedAddress + '。',
              uniAppContactid: JSON.parse(window.localStorage.userInfo).appContactId
            }


            addConsulting(params).then(res => {
              if (res.data.success) {
                that.loading = false;
                that.getInfo()
                that.$message.success(res.data.message)
                // 清除延迟执行
                clearTimeout(that.timer)
                // 设置延迟执行,这里设置延迟两秒执行
                that.timer = setTimeout(() => {
                  that.$router.go(-3)
                }, 2000)
              } else {
                that.$message.fail(res.data.message)
              }
            }).catch(() => {
              that.loading = false;
              that.$message.fail('提交失败')
            })

          } else {
            that.loading = false;
            console.log('error submit!!')
            return false
          }
        })
      },
      // 根据userId获取用户信息
      getInfo () {
        const params = JSON.parse(window.localStorage.userInfo).id
        getUserInfo(params).then(res => {
          if (res.data.success) {
            window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
          }
        }).catch(() => {
        })
      },


      //提示
      prompt(){
        this.$message({
          message: '请提供详细的地址，我们将及时为您更正，并在三个工作日内回复！',
          type: 'warning',
          duration:10000,
          showClose:true
        });
      }

    },

   created () {
      this.prompt()
   }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 40% 57px 40%;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  /deep/ .el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #BD1A2D;
    color: #BD1A2D;
  }

  /deep/.el-loading-spinner .path{
    stroke:#BD1A2D;
  }


</style>
